import { render } from "./WithAccessLevel.vue?vue&type=template&id=46a2d9c8&lang=pug"
import script from "./WithAccessLevel.vue?vue&type=script&lang=js"
export * from "./WithAccessLevel.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__